<template>
  <div v-if="isShowPwd" class="change-password-dialog">
    <el-dialog
        title="修改密码"
        :visible="isShowPwd"
        :close-on-click-modal="false"
        @close="closeDialog"
        width="450px">
      <el-form class="form" :model="vForm" :rules="rules" ref="vForm">
        <el-form-item class="form-group" prop="old_password">
          <el-input type="text" class="form-control" v-model="vForm.old_password" clearable auto-complete="off"
                    placeholder="请填写原密码"/>
        </el-form-item>
        <el-form-item class="form-group" prop="password">
          <el-input type="password" class="form-control" v-model="vForm.password" show-password
                    auto-complete="new-password"
                    placeholder="6-16位必须同时包含大写字母小写字母数字和特殊字符"/>
        </el-form-item>
        <el-form-item class="form-group" prop="password_check">
          <el-input type="password" class="form-control" v-model="vForm.password_check" show-password
                    auto-complete="new-password"
                    placeholder="请确认新密码"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {setPassword} from '@/api/user'

  export default {
    props: ['isShowPwd'],
    data() {
      let passwordCheck = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('新密码必填'));
        }
        let reg = /^.*(?=.{6,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%^&*?\(\)]).*$/;
        if (!reg.test(value)) {
          callback(new Error('6-16位必须同时包含大写字母小写字母数字和特殊字符'));
        } else {
          callback()
        }
      };
      let password2Check = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('确认密码必填'));
        }
        if (value !== this.vForm.password) {
          callback(new Error('两次密码不一致，请重新填写'));
        } else {
          callback()
        }
      };
      return {
        doSubmitLoading: false,
        vForm: {
          old_password: '',
          password: '',
          password_check: ''
        },
        rules: {
          old_password: {required: true, message: '原密码必填', trigger: 'blur'},
          password: {validator: passwordCheck, trigger: 'blur'},
          password_check: {validator: password2Check, trigger: 'blur'}
        }
      }
    },
    methods: {
      closeDialog() {
        this.$emit('update:isShowPwd', false)
      },
      async doSubmit() {
        try {
          this.doSubmitLoading = true;
          let res = setPassword(this.vForm);
          this.closeDialog();
          this.$message.success(res.message)
        } catch (e) {
          console.warn(e)
          this.doSubmitLoading = false
        }
      }
    }
  }
</script>

<style lang="scss">


</style>


// WEBPACK FOOTER //
// src/layout/components/TopBar/PwdDialog.vue